import { createAnalyticsChannel } from '@muse/analytics'

export type TSongParams = {
  requestId?: number
  songId?: number
  reason?: string
}

export const enum TSongEventName {
  Approve = 'approve',
  Reject = 'reject',
  Cancel = 'cancel',
  Counteroffer = 'counteroffer',
}

type TSongEventApprove = {
  event: TSongEventName.Approve
  requestId: number
  songId: number
}

type TSongEventReject = {
  event: TSongEventName.Reject
  requestId: number
  songId: number
  reason: string
}

type TSongEventCancel = {
  event: TSongEventName.Cancel
  requestId: number
  songId: number
}

type TSongEventCounteroffer = {
  event: TSongEventName.Counteroffer
  requestId: number
  songId: number
}

export type TSongEvent =
  | TSongEventApprove
  | TSongEventReject
  | TSongEventCancel
  | TSongEventCounteroffer

export const songChannel = createAnalyticsChannel<TSongEvent, TSongParams>('song')
